import React from 'react';
import './index.scss';

const Line = () => {
   return (
      <div className='line__custom__css' />
   );
};

Line.propTypes = {

};

export default Line;
